module.exports = __webpack_public_path__ + "static/media/807NorthAvenueNW_2018-07-09_152.01c65c4c.jpg";